import { render, staticRenderFns } from "./TagsDialog.vue?vue&type=template&id=45019510&scoped=true&"
import script from "./TagsDialog.vue?vue&type=script&lang=js&"
export * from "./TagsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45019510",
  null
  
)

export default component.exports